import { render, staticRenderFns } from "./SearchConfiguration.vue?vue&type=template&id=906671f4&"
import script from "./SearchConfiguration.vue?vue&type=script&lang=ts&"
export * from "./SearchConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports